import { render } from "./PortStatusSection.vue?vue&type=template&id=2ff43f5e&scoped=true"
import script from "./PortStatusSection.vue?vue&type=script&lang=js"
export * from "./PortStatusSection.vue?vue&type=script&lang=js"

import "./PortStatusSection.vue?vue&type=style&index=0&id=2ff43f5e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ff43f5e"]])

export default __exports__